import React from 'react';
import { useTranslation } from 'react-i18next';
import PageLayout from 'components/PageLayout';
import { useGetAssociation } from 'legacy/groups/hooks';
import { useRouter } from 'next/router';
import CenteredContainer from 'components/CenteredContainer';
import { metaData } from '../metaData';
import { useAssociationAnalyticsBigSpenders } from '../hooks/useAssociationAnalyticsBigSpenders';
import TopNCard from 'screens/organizations/components/OrganizationAnalytics/components/TopN/TopNCard';
import TopNCardSkeleton from 'screens/organizations/components/OrganizationAnalytics/components/TopN/TopNCardSkeleton';
import AssociationAdminLayout from 'screens/associations/components/AssociationAdminLayout';
import { buildAnalyticsCardData } from 'screens/organizations/components/OrganizationAnalytics/components/TopN/utils/analyticsCardBuilder';

const BigSpenders = () => {
  const { t } = useTranslation(['associations']);
  const router = useRouter();
  const associationId = router.query.associationId as string;
  const { data: association } = useGetAssociation({
    associationId
  });

  const {
    data: bigSpenders,
    isLoading: bigSpendersLoading,
    error: bigSpendersError
  } = useAssociationAnalyticsBigSpenders(associationId, 100);

  const key = 'big-spenders';
  const localizedMetaData = metaData(t);
  const cardData = buildAnalyticsCardData(
    key,
    bigSpenders,
    bigSpendersError,
    localizedMetaData[key].valueType,
    localizedMetaData
  );

  return (
    <AssociationAdminLayout
      goBackDestination={`/associations/${associationId}/analytics`}
    >
      <PageLayout hidePageMenu isAdmin={association?.isUserAdmin}>
        <CenteredContainer wideContent>
          <div className="-mt-4 pt-11 gap-8 flex flex-col">
            {!bigSpendersLoading && cardData ? (
              <TopNCard showViewAll={false} {...cardData} />
            ) : (
              <TopNCardSkeleton />
            )}
          </div>
        </CenteredContainer>
      </PageLayout>
    </AssociationAdminLayout>
  );
};

export { BigSpenders };
export default BigSpenders;